module.exports = __webpack_public_path__ + "static/media/tentakool_logo.2386fb85.png";